import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { default as deTitles } from '../i18n/de.titles.json';
import { mdcStockPostingRoutes } from './mdc-stock-posting.routes';
import {
  SOFTLINE_PERMISSION_MDC_STOCK_POSTING,
  SOFTLINE_ROUTE_MDC_STOCK_POSTING,
} from './mdc-stock-posting.shared';

// Legacy (monolith) entry — the NF shell loads src/federation/* instead.
// Two-export pattern: keep this and the federation entries in sync.
export const provideMdcStockPostingModule = (): Array<
  Provider | EnvironmentProviders
> => [
  provideSoftAppsModule(
    {
      name: 'MdcStockPosting',
      title: '#MDC_STOCK_POSTING.MODULE_TITLE',
      icon: 'fa-regular fa-boxes-packing',
      route: SOFTLINE_ROUTE_MDC_STOCK_POSTING,
      permission: SOFTLINE_PERMISSION_MDC_STOCK_POSTING,
      group: getModuleGroupById(6),
    },
    withSoftAppsModuleRoutes({ app: mdcStockPostingRoutes }),
    withLazySoftAppsModuleTranslation({
      eager: { de: deTitles },
      lazy: { de: () => import('../i18n/de.json') },
    })
  ),
];
